import styles from './icon.module.scss';
import {classNames} from '../../support/classnames.ts';
import {CSSProperties} from 'react';

export enum IconSize {
    Normal,
    Large,
}
interface OwnProps {
    alt?: string;
    src?: string;
    iconClassName?: string;
    outline?: boolean;
    size?: IconSize;
    style?: CSSProperties;
}
export function Icon({alt, src, iconClassName, outline, size, style}: OwnProps) {
    return (
        <div
            style={style}
            className={classNames(styles.icon, {
                [styles.large]: size === IconSize.Large,
                [styles.outline]: outline === undefined || outline,
            })}
        >
            {src && (
                <div className={styles.icon__image}>
                    <img src={src} alt={alt ?? ''} onError={(e) => (e.currentTarget.style.display = 'none')} />
                </div>
            )}

            {iconClassName && (
                <div className={styles.icon__icon}>
                    <i className={iconClassName} />
                </div>
            )}
        </div>
    );
}
